<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText">It is one of the most fundamental questions facing America today: How justifiably, or irresponsibly, do the volatile and unbiased American media—press, television and radio—attempt to interfere with, and control, the political process and the foreign policy of the nation? In a hotly fought Presidential primary, the news media fractures along ideological lines, supporting and distorting the candidates’ records, manipulating the news rather than covering it.  </p>
<p class="P_WFP_BodyText"><i>Capable of Honor</i>, the third novel in the grand, bestselling <i>Advise and Consent</i> saga, is a compelling blockbuster that shines a harsh and revealing spotlight on how the media shapes the news, guides public opinion, creates policy—and tries to shape history itself.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?b0cb1f02